<input
  type="text"
  [readOnly]="!isEditing"
  (input)="onInput()"
  [ngClass]="ngClassMap"
  [class]="customClass"
/>
